import React from "react";
import Section from "../Section";
import BannerSectionStyle3 from "../Section/BannerSection/BannerSectionStyle3";
import "./Brand.scss";

const brandData = [
  {
    logo: "/images/icons/cognivance.png",
    name: "COGNIVANCE",
    composition: "Trans-Pterostilbene (Silbinol) 450 mg",
    usp: [
      "Targets oxidative stress and neuroinflammation at the hippocampal level.",
      "Superior bioavailability compared to resveratrol; ideal for MCI and early cognitive decline.",
    ],
  },
  {
    logo: "/images/icons/palmisafe.png",
    name: "Palmisafe",
    composition:
      "Palmitoylethanolamide 600 mg + L-arginine (Agmatine) 450 mg + Cytidine Monophosphate 50 mg + Uridine Monophosphate 40 mg",
    usp: [
      "Promotes nerve repair and reduces oxidative neuronal damage.",
      "Ideal supportive therapy in neuropathy, nerve compression and chronic nerve injury.",
    ],
  },
  {
    logo: "/images/icons/rozucel.png",
    name: "Rozulec GOLD",
    composition: "Rosuvastatin 10 mg + Aspirin 75 mg + Clopidogrel 75 mg",
    usp: [
      "Dual benefit on endothelial function and neuronal health.",
      "Preferred in cardiovascular patients with associated neurological risk.",
    ],
  },
  {
    logo: "/images/icons/migrenta.png",
    name: "Migrenta",
    composition:
      "Magnesium 400 mg + Riboflavin 200 mg + Co-Q10 100 mg + L-Methylfolate 40 mg + Vitamin-D3 600 IU",
    usp: [
      "Reduces neuronal hyperexcitability and stabilizes neurovascular tone.",
      "Effective preventive support in episodic and stress-related migraine.",
    ],
  },
  {
    logo: "/images/icons/riventra.png",
    name: "Riventra",
    composition: "Resveratrol 250 mg + Omega 3-6-9 + Essential Vitamins",
    usp: [
      "Supports blood-brain barrier integrity and neuronal membrane repair.",
      "Ideal adjunct in stroke recovery, TBI, Parkinsonisms and neurodegenerative disorders.",
    ],
  },
  {
    logo: "/images/icons/solvira.png",
    name: "Solvira",
    composition: "Escitalopram 10/20 mg",
    usp: [
      "Improves serotonergic balance without excessive sedation.",
      "Suitable for long-term management of depression and anxiety spectrum disorders.",
    ],
  },
 
];

/**
 * Groups brands into pyramids of pattern 3-2-1 (6 per pyramid).
 * Any remaining brands start a new pyramid.
 * e.g. 7 brands → pyramid1: [3,2,1], pyramid2: [1]
 *      9 brands → pyramid1: [3,2,1], pyramid2: [3]
 *     12 brands → pyramid1: [3,2,1], pyramid2: [3,2,1]
 */
const buildPyramids = (data) => {
  const PYRAMID_SIZE = 6; // 3+2+1
  const pyramids = [];
  for (let i = 0; i < data.length; i += PYRAMID_SIZE) {
    const chunk = data.slice(i, i + PYRAMID_SIZE);
    const rows = [];
    // Row sizes: 3, 2, 1
    const rowSizes = [3, 2, 1];
    let idx = 0;
    for (const size of rowSizes) {
      if (idx >= chunk.length) break;
      rows.push(chunk.slice(idx, idx + size));
      idx += size;
    }
    pyramids.push(rows);
  }
  return pyramids;
};

const pyramids = buildPyramids(brandData);

const BrandCircle = ({ brand }) => (
  <div className="brand-circle">
    <div className="circle-logo">
      <img src={brand.logo} alt={brand.name} />
    </div>
    <p className="circle-composition">
      <strong>Composition: </strong>
      {brand.composition}
    </p>
    <p className="circle-usp-label">Differential USP:</p>
    <ul className="circle-usp">
      {brand.usp.map((point, i) => (
        <li key={i}>{point}</li>
      ))}
    </ul>
  </div>
);

export default function Brand() {
  return (
    <>
      <BannerSectionStyle3
        bgUrl="/images/about/banner_bg.jpg"
        imgUrl="/images/about/banner_img.png"
        title="Key Brands – Composition & Differential USP"
      />

      <Section topMd={0} bottomMd={0} bottomLg={0} className="brand-page">
        <div className="brand-circles-wrapper">
          {pyramids.map((rows, pyramidIdx) => (
            <div className="brand-pyramid" key={pyramidIdx}>
              {rows.map((row, rowIdx) => (
                <div className="brand-row" key={rowIdx}>
                  {row.map((brand, idx) => (
                    <BrandCircle key={idx} brand={brand} />
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </Section>
    </>
  );
}
